import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { User } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface GetUserByIdParams extends DefaultHttpHeaders {
  userId: string;
}

@Injectable()
export class GetUserByIdService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Get user information service. (Validate if the user requested is the logged user (By token))
   * Get user information service. (Validate if the user requested is the logged user (By token))
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/getUserById
   */
  getUserById(params: GetUserByIdParams): Observable<User> {
    const pathParams = {
      userId: params.userId,
    };
    return this.get<User>({
      suffix: `/applicationUtilities/user/${pathParams.userId}`,
      authenticationType: 'jwt',
    });
  }
}
